import infoPopoversPageTemplate from './infoPopoversPageTemplate.html';

const infoPopoversPage = {
    bindings: {
        content: '@',
        actionOnly: '@',
        referingPage:'@',
        moreInfo: '@'
    },
    template: `<button type="button" class="button button-clear button-balanced icon icon-right ion-ios-information page--icon" ng-class="{'action--icon': $ctrl.actionOnly}" ng-click="$ctrl.openPopover($event)"></button>`,
    controller: function($scope, $ionicPopover) {
        const content = this.content;

        // .fromTemplate() method
        var template = infoPopoversPageTemplate;

        this.popover = $ionicPopover.fromTemplate(template, { scope: $scope });

        this.openPopover = ($event) => {
          this.popover.show($event);
        };

        this.closePopover = () => {
          this.popover.hide();
        };
        //Cleanup the popover when we're done with it!
        $scope.$on('$destroy', () => {
          this.popover.remove();
        });
        // Execute action on hide popover
        $scope.$on('popover.hidden', () => {
          // Execute action
        });
        // Execute action on remove popover
        $scope.$on('popover.removed', () => {
          // Execute action
        });

    }
};

export default infoPopoversPage;



/** WEBPACK FOOTER **
 ** ./src/app/directives/popovers/infoPopoversPage.js
 **/